import { useContext } from "react";
import publicContex from "../context/PublicContex";

export default () => useContext(publicContex);

